"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, Crosshair } from "lucide-react";
const capabilities = [];
export default function Luxurypatioservices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}